module.exports = __webpack_public_path__ + "img/changeProfilepixicon.ecf34401.svg";